import { Page } from 'compositions/Page'

import { AdminSection } from '../settings/admin-section'

export function AdminIntegrations() {
  return (
    <Page>
      <h1 className="mb-6 text-xl font-semibold">Integrations</h1>
      <AdminSection />
    </Page>
  )
}
